module.exports = __webpack_public_path__ + "img/Path 16 Copy 3@3x.1954d0d9.png";